import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { openDialogFn } from '@helpers';
import { DialogWrapper } from './dialog-wrapper/dialog-wrapper';
import type { DialogConfig, DialogResult } from '@appTypes';

@Injectable({
  providedIn: 'root',
})
export class Dialogs {
  // Dependencias
  private readonly openDialog = openDialogFn(inject(Dialog));

  // Abre el componente como diálogo utilizando el wrapper visual
  open<T extends Record<string, unknown>, K>(component: ComponentType<unknown>, config?: DialogConfig<T> & { closeButton?: boolean }): DialogResult<K> {
    return this.openDialog(DialogWrapper, {
      data: {
        component,
        inputs: config?.data,
        closeButton: config?.closeButton !== false,
      },
      backdropClass: config?.backdropClass,
      panelClass: config?.panelClass,
      easyClose: config?.easyClose,
      width: config?.width ?? '60lvw',
      minWidth: config?.minWidth,
      maxWidth: config?.maxWidth,
      height: config?.height ?? '70lvh',
      minHeight: config?.minHeight,
      maxHeight: config?.maxHeight,
    });
  }
}
